"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _roundTo = _interopRequireDefault(require("round-to"));

var _checkTypes = _interopRequireDefault(require("check-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var round = function round(n) {
  return (0, _roundTo["default"])(n, 2);
};

var roundObj = function roundObj(o) {
  return Object.keys(o).reduce(function (acc, val) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, val, _checkTypes["default"].number(o[val]) ? round(o[val]) : o[val]));
  }, {});
};

var BuseaApi = /*#__PURE__*/function () {
  function BuseaApi() {
    _classCallCheck(this, BuseaApi);
  }

  _createClass(BuseaApi, null, [{
    key: "getBuseaFee",
    value: function getBuseaFee(grossPrice, companyFee, withTwoWaysTripReduction) {
      var totalBeforePayment = grossPrice; // + (companyFee || 0);

      return Math.min(withTwoWaysTripReduction ? 1 : 2, (withTwoWaysTripReduction ? 0.175 : 0.35) + (0, _roundTo["default"])(4 * totalBeforePayment / 100, 2));
    }
  }, {
    key: "getStripeFee",
    value: function getStripeFee(grossPrice, companyFee, buseaFee, withTwoWaysTripReduction) {
      var cartTotalOnTrip = grossPrice + (companyFee || 0) + (buseaFee || 0);
      var stripeMinimumFee = withTwoWaysTripReduction ? 0.15 : 0.3;

      function getStripePercentageFeeIncludingFeeOnFee(fee) {
        if (!_checkTypes["default"].number(fee)) {
          return 0;
        }

        var raw = 2.9 * fee / 100;

        if (raw < 0.005) {
          return 0;
        }

        var out = (0, _roundTo["default"])(raw, 2);
        return round(out + getStripePercentageFeeIncludingFeeOnFee(out));
      }

      var stripePercentFee = getStripePercentageFeeIncludingFeeOnFee(cartTotalOnTrip + stripeMinimumFee);
      return round(stripeMinimumFee + stripePercentFee);
    }
    /*
    static getBuseaFeeOnCart(grossPrice, companyFee) {
      return BuseaApi.getBuseaFee(grossPrice, companyFee, false);
    }
     static getStripeFeeOnCart(grossPrice, companyFee, buseaFee) {
      return BuseaApi.getStripeFee(grossPrice, companyFee, buseaFee, false);
    }
    */

  }, {
    key: "getBuseaFeeOnTrip",
    value: function getBuseaFeeOnTrip(grossPrice, companyFee, isTwoWaysTrip) {
      return BuseaApi.getBuseaFee(grossPrice, companyFee, isTwoWaysTrip);
    }
  }, {
    key: "getStripeFeeOnTrip",
    value: function getStripeFeeOnTrip(grossPrice, companyFee, buseaFee, isTwoWaysTrip) {
      return BuseaApi.getStripeFee(grossPrice, companyFee, buseaFee, isTwoWaysTrip);
    }
  }, {
    key: "getTripPricing",
    value: function getTripPricing(ticketDetails) {
      var nPassengers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var isTwoWaysTrip = arguments.length > 2 ? arguments[2] : undefined;
      // Calculate ticket fees
      var grossPrice = ticketDetails.grossPrice,
          companyFee = ticketDetails.fee,
          selectedSeats = ticketDetails.selectedSeats;
      var singleTicketPricing = {
        grossPrice: grossPrice,
        companyFee: companyFee
      }; // FIXME: We should make sure selectedSeats are always privided on frontend
      // Not providing it before payment on client may result in server having a different order price

      var tripPrice = _checkTypes["default"].nonEmptyArray(selectedSeats) ? selectedSeats.map(function (s) {
        return s.priceInCents / 100 - (companyFee || 0);
      }).reduce(function (acc, val) {
        return acc + val;
      }, 0) : nPassengers * grossPrice;
      var totalCompanyFees = nPassengers * (companyFee || 0);
      var buseaFee = BuseaApi.getBuseaFeeOnTrip(tripPrice, totalCompanyFees, isTwoWaysTrip);
      var paymentFee = BuseaApi.getStripeFeeOnTrip(tripPrice, totalCompanyFees, buseaFee, isTwoWaysTrip);
      var tripPricing = {
        grossPrice: tripPrice,
        companyFee: totalCompanyFees,
        buseaFee: buseaFee,
        paymentFee: paymentFee,
        total: tripPrice + totalCompanyFees + buseaFee + paymentFee,
        singleTicketPricing: singleTicketPricing
      };
      return roundObj(tripPricing);
    }
  }, {
    key: "getOrderPricing",
    value: function getOrderPricing(outboundTripDetails, returnTripDetails) {
      var nPassengers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var isTwoWaysTrip = !!returnTripDetails;
      var outboundTripPricing = BuseaApi.getTripPricing(outboundTripDetails, nPassengers, isTwoWaysTrip);
      var returnTripPricing = returnTripDetails ? BuseaApi.getTripPricing(returnTripDetails, nPassengers, isTwoWaysTrip) : null;
      var grossPrice = outboundTripPricing.grossPrice + (returnTripPricing ? returnTripPricing.grossPrice : 0);
      var companyFee = outboundTripPricing.companyFee + (returnTripPricing ? returnTripPricing.companyFee : 0);
      var buseaFee = outboundTripPricing.buseaFee + (returnTripPricing ? returnTripPricing.buseaFee : 0);
      var paymentFee = outboundTripPricing.paymentFee + (returnTripPricing ? returnTripPricing.paymentFee : 0);
      var total = grossPrice + companyFee + buseaFee + paymentFee;
      var orderPricing = {
        grossPrice: grossPrice,
        companyFee: companyFee,
        buseaFee: buseaFee,
        paymentFee: paymentFee,
        total: total,
        outboundTripPricing: outboundTripPricing,
        returnTripPricing: returnTripPricing
      };
      return roundObj(orderPricing);
    }
  }]);

  return BuseaApi;
}();

exports["default"] = BuseaApi;